import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class CategoryAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            formData : {
                name:'',
                description:''
            }
        }
    }

    handleChange = (e) => {
        const {id,value} = e.target;
        this.setState(prevState => ({
            formData : {
                ...prevState.formData,
                [id] : value
            }
        }))
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({loading:true});
        const {formData} = this.state;
        const categoryFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            if(formData[key]) {
                categoryFormData.append(key,formData[key]);
            }
        });

        try {
            const response = await apiCall('business/stock/category/add','post',categoryFormData);
            this.setState({loading:false});
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.props.history.push('/stock/categories');
            }
        }catch (e) {
            this.setState({loading:false});
        }
    }

    render() {
        const {loading, formData} = this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Ana Kategori Ekle"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Ana Kategoriler", navigate: "stock/categories" },
                                { name: "Yeni Ana Kategori", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="alert alert-info">
                                                    <strong>📁 Ana Kategori:</strong> Burada oluşturacağınız kategori bir <strong>Ana Kategori</strong> olacaktır.
                                                    Alt kategorileri daha sonra bu kategorinin detay sayfasından ekleyebilirsiniz.
                                                </div>
                                                <div className="form-group">
                                                    <label>Ana Kategori Adı *</label>
                                                    <input
                                                        id="name"
                                                        className="form-control"
                                                        placeholder="Örn: Yedek Parça, Aksesuar, Kimyasal"
                                                        type="text"
                                                        value={formData.name}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Açıklama</label>
                                                    <textarea
                                                        id="description"
                                                        className="form-control"
                                                        placeholder="Açıklama"
                                                        rows="3"
                                                        value={formData.description}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                    <button className="btn btn-outline-primary btn-block" disabled={true} style={{textAlign: "-webkit-center"}}>
                                                        Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"></ReactLoading>
                                                    </button>
                                                ) :
                                                <button className="btn btn-outline-primary btn-block" type="submit">
                                                    Kaydet
                                                </button>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(CategoryAdd));

